import { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import BtChecklistSelect from '../bt-checklist-select/bt-checklist-select';
import { countyChecklist, countyGenitive, CountyMap } from './countyChecklist';

type Props = {
  counties: CountyMap;
  value: string[];
  onChange: (values: string[]) => void;
};

const CountyMunicipalityChecklist: FC<Props> = ({ counties, value, onChange }) => {
  const [t] = useTranslation('supplierDatabase');
  const options = useMemo(
    () =>
      countyChecklist(counties, county =>
        t('filter.countyMunicipality.county', {
          name: county,
          genitive: countyGenitive(county),
          defaultValue: '{{genitive}} län',
        }),
      ),
    [counties, t],
  );
  return (
    <BtChecklistSelect
      placeholder={t('filter.countyMunicipality.placeholder', 'Län / kommun')}
      options={options}
      value={value}
      onChange={onChange}
      groupsSelectable
    />
  );
};

export default CountyMunicipalityChecklist;
